// extracted by mini-css-extract-plugin
export var button = "_mj-0";